import type { RouteRecordRaw } from "vue-router";
import { ROUTE_NAME } from "@/shared/constants/routes";
import UserDetailView from "./views/UserDetailView.vue";
import { h } from "vue";
import { RouterView } from "vue-router";

export const routes: RouteRecordRaw[] = [
  {
    path: "/users",
    name: ROUTE_NAME.USERS,
    component: { render: () => h(RouterView) },
    redirect: { name: ROUTE_NAME.USER_LIST },
    children: [
      {
        path: "",
        name: ROUTE_NAME.USER_LIST,
        component: () => import("./views/UserList.vue"),
      },
      {
        path: ":id",
        name: ROUTE_NAME.USER_DETAIL,
        component: UserDetailView,
      },
      {
        path: ":id/edit",
        name: ROUTE_NAME.USER_UPDATE,
        component: () => import("./views/UserUpdate.vue"),
      },
      {
        path: "create",
        name: ROUTE_NAME.USER_CREATE,
        component: () => import("./views/UserCreate.vue"),
      },
    ],
  },
];
